import axios from 'axios';
import { AUTH_PATH } from '~/nasa_ui/constants';
import { CosmicEnvironment, getEnvironment } from '~/nasa_ui/types';
export const fetchCurrentUser = async () => {
    try {
        // if you put this value in local storage, it allows you to use the system as that user.
        // this accountId can be created using the API's CLI command, add-user CONTEXT ADMIN|USER.
        const devUserAccountId = window.localStorage.getItem('devUserAccountId');
        const env = getEnvironment();
        const headers = {};
        // for security, also check for localhost
        // API2 doesnt look at this header it gets the accountId from the JWT sent over by keycloak
        if (devUserAccountId && env === CosmicEnvironment.LOCAL) {
            headers['x-auth-subject'] = devUserAccountId;
        }
        const v2HttpClient = axios.create({
            baseURL: `/api2`,
            headers
        });
        v2HttpClient.interceptors.response.use((response) => {
            return response;
        }, (error) => {
            if (error.response.status === 401) {
                window.location.href = AUTH_PATH;
                return;
            }
            if (error.response.status === 403) {
                window.location.href = '/no_access';
                return;
            }
            return Promise.reject(error);
        });
        const resp = await v2HttpClient.get('/users/current');
        const currentUser = resp.data;
        if (!currentUser) {
            console.error('Couldnt get the current user');
            return null;
        }
        return currentUser;
    }
    catch (err) {
        return Promise.reject(err);
    }
};
